import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CallQueuesQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  groupId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CallQueuesQuery = { __typename?: 'Query', callQueues?: Array<{ __typename?: 'CallQueue', id?: number | null, name?: string | null, acwLength?: number | null, huntingAlgorithmType?: Types.HuntingAlgorithmType | null, sequentialTimeout?: number | null, maxQueueLength?: number | null, maxWaitingTime?: number | null, outgoingCallBarringOperator?: Array<Types.OutgoingCallBarring | null> | null, outgoingCallBarringAdmin?: Array<Types.OutgoingCallBarring | null> | null, hasAddressBook?: boolean | null, priority?: number | null, media?: { __typename?: 'CallQueueMediaFiles', queueFull?: { __typename?: 'MediaFileInfo', id: number, description: string, downloadToken: string } | null, queueTimeout?: { __typename?: 'MediaFileInfo', id: number, description: string, downloadToken: string } | null, waiting?: { __typename?: 'MediaFileInfo', id: number, description: string, downloadToken: string } | null } | null } | null> | null };

export type CallQueueLimitQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CallQueueLimitQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', ccQueue: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null } } } };


export const CallQueuesDocument = gql`
    query CallQueues($domainId: Int!, $groupId: Int) {
  callQueues(domainId: $domainId, groupId: $groupId) {
    id
    name
    acwLength
    huntingAlgorithmType
    sequentialTimeout
    maxQueueLength
    maxWaitingTime
    outgoingCallBarringOperator
    outgoingCallBarringAdmin
    hasAddressBook
    priority
    media {
      queueFull {
        id
        description
        downloadToken
      }
      queueTimeout {
        id
        description
        downloadToken
      }
      waiting {
        id
        description
        downloadToken
      }
    }
  }
}
    `;

/**
 * __useCallQueuesQuery__
 *
 * To run a query within a React component, call `useCallQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallQueuesQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCallQueuesQuery(baseOptions: Apollo.QueryHookOptions<CallQueuesQuery, CallQueuesQueryVariables> & ({ variables: CallQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallQueuesQuery, CallQueuesQueryVariables>(CallQueuesDocument, options);
      }
export function useCallQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallQueuesQuery, CallQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallQueuesQuery, CallQueuesQueryVariables>(CallQueuesDocument, options);
        }
export function useCallQueuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallQueuesQuery, CallQueuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallQueuesQuery, CallQueuesQueryVariables>(CallQueuesDocument, options);
        }
export type CallQueuesQueryHookResult = ReturnType<typeof useCallQueuesQuery>;
export type CallQueuesLazyQueryHookResult = ReturnType<typeof useCallQueuesLazyQuery>;
export type CallQueuesSuspenseQueryHookResult = ReturnType<typeof useCallQueuesSuspenseQuery>;
export type CallQueuesQueryResult = Apollo.QueryResult<CallQueuesQuery, CallQueuesQueryVariables>;
export const CallQueueLimitDocument = gql`
    query CallQueueLimit($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      ccQueue {
        domainAllocated
        domainUsed
        remaining
        allocationIncrementError {
          type
          context
        }
      }
    }
  }
}
    `;

/**
 * __useCallQueueLimitQuery__
 *
 * To run a query within a React component, call `useCallQueueLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallQueueLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallQueueLimitQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCallQueueLimitQuery(baseOptions: Apollo.QueryHookOptions<CallQueueLimitQuery, CallQueueLimitQueryVariables> & ({ variables: CallQueueLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallQueueLimitQuery, CallQueueLimitQueryVariables>(CallQueueLimitDocument, options);
      }
export function useCallQueueLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallQueueLimitQuery, CallQueueLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallQueueLimitQuery, CallQueueLimitQueryVariables>(CallQueueLimitDocument, options);
        }
export function useCallQueueLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallQueueLimitQuery, CallQueueLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallQueueLimitQuery, CallQueueLimitQueryVariables>(CallQueueLimitDocument, options);
        }
export type CallQueueLimitQueryHookResult = ReturnType<typeof useCallQueueLimitQuery>;
export type CallQueueLimitLazyQueryHookResult = ReturnType<typeof useCallQueueLimitLazyQuery>;
export type CallQueueLimitSuspenseQueryHookResult = ReturnType<typeof useCallQueueLimitSuspenseQuery>;
export type CallQueueLimitQueryResult = Apollo.QueryResult<CallQueueLimitQuery, CallQueueLimitQueryVariables>;